import styled from "styled-components/macro";

export const RespondentsDataButton = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  align-items: center;
`;
export const Icon = styled.div`
  font-size: 32px;
  margin-right: 12px;
  width: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
export const Text = styled.div``;
export const Title = styled.div`
  font-size: 20px;
  font-weight: 400;
`;
export const SubText = styled.div`
  font-size: 14px;
`;
